<p-panel header="{{ 'TIMESLICE'  | translate }}" styleClass="p-panel-whitebg">
	<div class="grid p-0 px-2 mb-5 lg:mb-3 mt-0 md:p-1">
		<div class="col-12">
			<p-table #tableTimesliceList dataKey="Id" [value]="mtmaTimeslices" (onLazyLoad)="loadTimeslices($event)"
				[paginator]="true" [totalRecords]="totalRecords" [loading]="timesliceLoading" [rows]="timeslicePageSize"
				[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="caption">
					<div class="grid">
						<div [class]="actionLayout('left')">
							<!-- <button pButton pRipple icon="pi cm-plus"
								label="{{ 'ADD_TIMESLICE' | translate }}" (click)="addTimeslice()" [disabled]="timesliceResultLength>=timesliceMaxMemorySize || isActiveTask"
								class="p-button-primary text-normal border-transparent font-medium py-1">
							</button> -->
							<p-button id="addMtmaTimeslice" label="{{ 'ADD_TIMESLICE' | translate }}" (click)="addTimeslice()"
								[disabled]="timesliceResultLength>=timesliceMaxMemorySize || isActiveTask" icon="pi cm-plus"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary">
							</p-button>
						</div>
						<div [class]="actionLayout('center')">
							<div class="flex flex-column justify-content-center gap-2">
								<span class="flex align-items-center justify-content-center">
									<i class="pi cm-memory-storage mr-1"></i>
									{{'MEMORY_USAGE' | translate }}: {{timesliceMemorySize}} / {{timesliceMaxMemorySize}}
								</span>
								<p-progressBar [value]="getValueMemory()">
									<ng-template pTemplate="content" let-value>
										<span *ngIf="getValueMemory() > 4">{{ getValueMemory() }} %</span>
									</ng-template>
								</p-progressBar>
							</div>
						</div>
						<div [class]="actionLayout('right')">
							<!--<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
								<i class="pi cm-search"></i>
								<input [formControl]="searchFilter" pInputText type="text"
									id="mtma-control-access-timeslices-input-search"
									placeholder="{{ 'SEARCH' | translate }}"
									[ngClass]="dynamicInputSearchWidth()"
									maxlength="60"/>
							</span>-->
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'ACCESS_MODE_EXCLUDE_INCLUDE' |
								translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'TYPE_TIMESLICE' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'PERIOD_DETAILS' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'FREQUENCY_VALIDITY' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'TIME_VALIDITY' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'REPETITION' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-timeslice>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ timeslice.Name }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'ACCESS_MODE_EXCLUDE_INCLUDE' | translate }}</span>
							<p-tag
								[value]="getIncludeExcludeTimeslice(timeslice) === 1 ? ('ACCESS_MODE_INCLUDE' | translate) : ('ACCESS_MODE_EXCLUDE' | translate)"
								[severity]="getIncludeExcludeTimeslice(timeslice) === 1 ? 'success' : 'danger'"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'TYPE_TIMESLICE' | translate }}</span>
							<p-tag [value]="getLabelTypeTag(timeslice)" [styleClass]="getColorTypeTag(timeslice)"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'PERIOD_DETAILS' | translate }}</span>
							<span *ngIf="getRepetitionTimeslice(timeslice) === 0">{{
								getLabelRepetition(getRepetitionTimeslice(timeslice)) }}</span>
							<p-tag *ngIf="getRepetitionTimeslice(timeslice) !== 0"
								[value]="getLabelRepetition(getRepetitionTimeslice(timeslice))"
								[styleClass]="getColorRepetition(getRepetitionTimeslice(timeslice))"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'FREQUENCY_VALIDITY' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getDetailsTimeslice(timeslice) }}
							</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'TIME_VALIDITY' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getTimeTimeslice(timeslice) }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'REPETITION' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getTemporaryTimeslice(timeslice) }}
							</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" id="buttonDeviceTimesliceEdit-{{timeslice.Name}}"
									[disabled]="timeslice.Fixed || isActiveTask" tooltipPosition="bottom" icon="pi cm-pencil"
									size="large" (click)="editTimeslice(timeslice)" [rounded]="false" [text]="true"
									severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}"
									id="buttonDeviceTimesliceDelete-{{timeslice.Name}}"
									[disabled]="timeslice.Fixed || isActiveTask" tooltipPosition="bottom" icon="pi cm-trash"
									size="large" (click)="deleteTimeslice(timeslice)" [rounded]="false" [text]="true"
									severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</p-panel>
<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>